import RatesContainer from './RatesContainer';

export default { RatesContainer };
